import {
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  makeStyles,
  MenuItem,
  Typography,
} from '@material-ui/core';
import TrafficSelect from 'App/Vehicles/shared/TrafficSelect';
import VehicleTypeSelect from 'App/Vehicles/shared/VehicleTypeSelect';
import React from 'react';
import { useSubstate } from 'use-substate';

import useProducts from 'core/hooks/useProducts';
import { selectUniqueProductSizes } from 'core/Store/products/selectors';
import {
  Form,
  FormSubmitHandler,
  InputField,
  SubmitButton,
} from 'Elements/Form';
import ResetButton from 'Elements/Form/ResetButton';
import SearchPane from 'Elements/SearchPane/SearchPane';

import OverMedianCheckbox from './OverMedianCheckbox';
import schema, { Schema } from './schema';

const useStyles = makeStyles((theme) => ({
  checkbox: {
    padding: '2px 9px',
  },
  formLabel: {
    margin: '10px 0px 10px 15px',
    fontSize: '12px',
  },
  button: {
    marginLeft: theme.spacing(1),
  },
}));

type Props = {
  onSubmit: FormSubmitHandler<Schema>;
};

export default function FilterSurfaceReport({ onSubmit }: Props) {
  const classes = useStyles();
  useProducts();
  const [sizes] = useSubstate(selectUniqueProductSizes);

  return (
    <SearchPane>
      <Typography variant="h6">Suodattimet</Typography>
      <Form
        onSubmit={onSubmit}
        initialValues={{ over_median: [1, -1] }}
        validationSchema={schema}
      >
        <InputField
          name="size"
          fullWidth
          select
          variant="outlined"
          helperText="Valitse"
          margin="normal"
          InputLabelProps={{
            shrink: true,
          }}
        >
          {sizes.map((size) => (
            <MenuItem key={size} value={size}>
              {size}
            </MenuItem>
          ))}
        </InputField>

        <FormLabel component="legend">Kuluma / km</FormLabel>
        <FormGroup>
          <FormControlLabel
            control={<OverMedianCheckbox value={1} />}
            label="Alle mediaanin"
          />
          <FormControlLabel
            control={<OverMedianCheckbox value={-1} />}
            label="Yli mediaanin"
          />
        </FormGroup>

        <VehicleTypeSelect name="vehicle_type_id" />
        <TrafficSelect name="traffic_id" />
        <Grid container justify="flex-end">
          <ResetButton className={classes.button} variant="contained">
            Nollaa
          </ResetButton>
          <SubmitButton
            className={classes.button}
            variant="contained"
            color="secondary"
          >
            Suodata
          </SubmitButton>
        </Grid>
      </Form>
    </SearchPane>
  );
}
